import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "ui container action-view-container" }
const _hoisted_2 = { class: "action-view-header" }
const _hoisted_3 = { class: "action-info-summary" }
const _hoisted_4 = { class: "action-info-summary-title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["data-url"]
const _hoisted_7 = { class: "action-commit-summary" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 2,
  class: "ui label tw-max-w-full"
}
const _hoisted_12 = ["data-tooltip-content"]
const _hoisted_13 = ["href", "data-tooltip-content"]
const _hoisted_14 = { class: "action-view-body" }
const _hoisted_15 = { class: "action-view-left" }
const _hoisted_16 = { class: "job-group-section" }
const _hoisted_17 = { class: "job-brief-list" }
const _hoisted_18 = ["href", "onMouseenter"]
const _hoisted_19 = { class: "job-brief-item-left" }
const _hoisted_20 = { class: "job-brief-name tw-mx-2 gt-ellipsis" }
const _hoisted_21 = { class: "job-brief-item-right" }
const _hoisted_22 = { class: "step-summary-duration" }
const _hoisted_23 = {
  key: 0,
  class: "job-artifacts"
}
const _hoisted_24 = { class: "job-artifacts-title" }
const _hoisted_25 = { class: "job-artifacts-list" }
const _hoisted_26 = ["href"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "action-view-right" }
const _hoisted_29 = { class: "job-info-header" }
const _hoisted_30 = { class: "job-info-header-left gt-ellipsis" }
const _hoisted_31 = { class: "job-info-header-title gt-ellipsis" }
const _hoisted_32 = { class: "job-info-header-detail" }
const _hoisted_33 = { class: "job-info-header-right" }
const _hoisted_34 = { class: "btn gt-interact-bg tw-p-2" }
const _hoisted_35 = { class: "icon" }
const _hoisted_36 = { class: "icon" }
const _hoisted_37 = { class: "icon" }
const _hoisted_38 = ["href"]
const _hoisted_39 = { class: "icon" }
const _hoisted_40 = {
  key: 0,
  class: "job-step-container",
  ref: "steps"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "step-summary-msg gt-ellipsis" }
const _hoisted_43 = { class: "step-summary-duration" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionRunStatus = _resolveComponent("ActionRunStatus")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ActionRunStatus, {
            "locale-status": _ctx.locale.status[_ctx.run.status],
            status: _ctx.run.status,
            size: 20
          }, null, 8 /* PROPS */, ["locale-status", "status"]),
          _createCommentVNode(" eslint-disable-next-line vue/no-v-html "),
          _createElementVNode("h2", {
            class: "action-info-summary-title-text",
            innerHTML: _ctx.run.titleHTML
          }, null, 8 /* PROPS */, _hoisted_5)
        ]),
        (_ctx.run.canApprove)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "ui basic small compact button primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.approveRun()))
            }, _toDisplayString(_ctx.locale.approve), 1 /* TEXT */))
          : (_ctx.run.canCancel)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "ui basic small compact button red",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelRun()))
              }, _toDisplayString(_ctx.locale.cancel), 1 /* TEXT */))
            : (_ctx.run.canRerun)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "ui basic small compact button link-action",
                  "data-url": `${_ctx.run.link}/rerun`
                }, _toDisplayString(_ctx.locale.rerun_all), 9 /* TEXT, PROPS */, _hoisted_6))
              : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", null, [
          _createElementVNode("a", {
            class: "muted",
            href: _ctx.run.workflowLink
          }, [
            _createElementVNode("b", null, _toDisplayString(_ctx.run.workflowID), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_8),
          _cache[8] || (_cache[8] = _createTextVNode(":"))
        ]),
        (_ctx.run.isSchedule)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.locale.scheduled), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.locale.commit) + " ", 1 /* TEXT */),
              _createElementVNode("a", {
                class: "muted",
                href: _ctx.run.commit.link
              }, _toDisplayString(_ctx.run.commit.shortSHA), 9 /* TEXT, PROPS */, _hoisted_9),
              _createTextVNode(" " + _toDisplayString(_ctx.locale.pushedBy) + " ", 1 /* TEXT */),
              _createElementVNode("a", {
                class: "muted",
                href: _ctx.run.commit.pusher.link
              }, _toDisplayString(_ctx.run.commit.pusher.displayName), 9 /* TEXT, PROPS */, _hoisted_10)
            ], 64 /* STABLE_FRAGMENT */)),
        (_ctx.run.commit.shortSHA)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
              (_ctx.run.commit.branch.isDeleted)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "gt-ellipsis tw-line-through",
                    "data-tooltip-content": _ctx.run.commit.branch.name
                  }, _toDisplayString(_ctx.run.commit.branch.name), 9 /* TEXT, PROPS */, _hoisted_12))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "gt-ellipsis",
                    href: _ctx.run.commit.branch.link,
                    "data-tooltip-content": _ctx.run.commit.branch.name
                  }, _toDisplayString(_ctx.run.commit.branch.name), 9 /* TEXT, PROPS */, _hoisted_13))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.run.jobs, (job, index) => {
              return (_openBlock(), _createElementBlock("a", {
                class: _normalizeClass(["job-brief-item", parseInt(_ctx.jobIndex) === index ? 'selected' : '']),
                href: _ctx.run.link+'/jobs/'+index,
                key: job.id,
                onMouseenter: ($event: any) => (_ctx.onHoverRerunIndex = job.id),
                onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onHoverRerunIndex = -1))
              }, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_ActionRunStatus, {
                    "locale-status": _ctx.locale.status[job.status],
                    status: job.status
                  }, null, 8 /* PROPS */, ["locale-status", "status"]),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(job.name), 1 /* TEXT */)
                ]),
                _createElementVNode("span", _hoisted_21, [
                  (job.canRerun && _ctx.onHoverRerunIndex === job.id)
                    ? (_openBlock(), _createBlock(_component_SvgIcon, {
                        key: 0,
                        name: "octicon-sync",
                        role: "button",
                        "data-tooltip-content": _ctx.locale.rerun,
                        class: "job-brief-rerun tw-mx-2 link-action",
                        "data-url": `${_ctx.run.link}/jobs/${index}/rerun`
                      }, null, 8 /* PROPS */, ["data-tooltip-content", "data-url"]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(job.duration), 1 /* TEXT */)
                ])
              ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_18))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        (_ctx.artifacts.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.locale.artifactsTitle), 1 /* TEXT */),
              _createElementVNode("ul", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artifacts, (artifact) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "job-artifacts-item",
                    key: artifact.name
                  }, [
                    _createElementVNode("a", {
                      class: "job-artifacts-link",
                      target: "_blank",
                      href: _ctx.run.link+'/artifacts/'+artifact.name
                    }, [
                      _createVNode(_component_SvgIcon, {
                        name: "octicon-file",
                        class: "ui text black job-artifacts-icon"
                      }),
                      _createTextVNode(_toDisplayString(artifact.name), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_26),
                    (_ctx.run.canDeleteArtifact)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.deleteArtifact(artifact.name)),
                          class: "job-artifacts-delete"
                        }, [
                          _createVNode(_component_SvgIcon, {
                            name: "octicon-trash",
                            class: "ui text black job-artifacts-icon"
                          })
                        ], 8 /* PROPS */, _hoisted_27))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.currentJob.title), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.currentJob.detail), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", {
              class: "ui top right pointing dropdown custom jump item",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.menuVisible = !_ctx.menuVisible), ["stop"])),
              onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.menuVisible = !_ctx.menuVisible), ["enter"]))
            }, [
              _createElementVNode("button", _hoisted_34, [
                _createVNode(_component_SvgIcon, {
                  name: "octicon-gear",
                  size: 18
                })
              ]),
              (_ctx.menuVisible)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["menu transition action-job-menu", {visible: _ctx.menuVisible}])
                  }, [
                    _createElementVNode("a", {
                      class: "item",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleTimeDisplay('seconds')))
                    }, [
                      _createElementVNode("i", _hoisted_35, [
                        _createVNode(_component_SvgIcon, {
                          name: _ctx.timeVisible['log-time-seconds'] ? 'octicon-check' : 'gitea-empty-checkbox'
                        }, null, 8 /* PROPS */, ["name"])
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.locale.showLogSeconds), 1 /* TEXT */)
                    ]),
                    _createElementVNode("a", {
                      class: "item",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleTimeDisplay('stamp')))
                    }, [
                      _createElementVNode("i", _hoisted_36, [
                        _createVNode(_component_SvgIcon, {
                          name: _ctx.timeVisible['log-time-stamp'] ? 'octicon-check' : 'gitea-empty-checkbox'
                        }, null, 8 /* PROPS */, ["name"])
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.locale.showTimeStamps), 1 /* TEXT */)
                    ]),
                    _createElementVNode("a", {
                      class: "item",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleFullScreen()))
                    }, [
                      _createElementVNode("i", _hoisted_37, [
                        _createVNode(_component_SvgIcon, {
                          name: _ctx.isFullScreen ? 'octicon-check' : 'gitea-empty-checkbox'
                        }, null, 8 /* PROPS */, ["name"])
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.locale.showFullScreen), 1 /* TEXT */)
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "divider" }, null, -1 /* HOISTED */)),
                    _createElementVNode("a", {
                      class: _normalizeClass(['item', !_ctx.currentJob.steps.length ? 'disabled' : '']),
                      href: _ctx.run.link+'/jobs/'+_ctx.jobIndex+'/logs',
                      target: "_blank"
                    }, [
                      _createElementVNode("i", _hoisted_39, [
                        _createVNode(_component_SvgIcon, { name: "octicon-download" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.locale.downloadLogs), 1 /* TEXT */)
                    ], 10 /* CLASS, PROPS */, _hoisted_38)
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true)
            ], 32 /* NEED_HYDRATION */)
          ])
        ]),
        (_ctx.currentJob.steps.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentJob.steps, (jobStep, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "job-step-section",
                  key: i
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["job-step-summary", [_ctx.currentJobStepsStates[i].expanded ? 'selected' : '', _ctx.isExpandable(jobStep.status) && 'step-expandable']]),
                    onClick: _withModifiers(($event: any) => (_ctx.isExpandable(jobStep.status) && _ctx.toggleStepLogs(i)), ["stop"])
                  }, [
                    _createCommentVNode(" If the job is done and the job step log is loaded for the first time, show the loading icon\n                currentJobStepsStates[i].cursor === null means the log is loaded for the first time\n              "),
                    (_ctx.isDone(_ctx.run.status) && _ctx.currentJobStepsStates[i].expanded && _ctx.currentJobStepsStates[i].cursor === null)
                      ? (_openBlock(), _createBlock(_component_SvgIcon, {
                          key: 0,
                          name: "octicon-sync",
                          class: "tw-mr-2 job-status-rotate"
                        }))
                      : (_openBlock(), _createBlock(_component_SvgIcon, {
                          key: 1,
                          name: _ctx.currentJobStepsStates[i].expanded ? 'octicon-chevron-down': 'octicon-chevron-right',
                          class: _normalizeClass(['tw-mr-2', !_ctx.isExpandable(jobStep.status) && 'tw-invisible'])
                        }, null, 8 /* PROPS */, ["name", "class"])),
                    _createVNode(_component_ActionRunStatus, {
                      status: jobStep.status,
                      class: "tw-mr-2"
                    }, null, 8 /* PROPS */, ["status"]),
                    _createElementVNode("span", _hoisted_42, _toDisplayString(jobStep.summary), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_43, _toDisplayString(jobStep.duration), 1 /* TEXT */)
                  ], 10 /* CLASS, PROPS */, _hoisted_41),
                  _createCommentVNode(" the log elements could be a lot, do not use v-if to destroy/reconstruct the DOM,\n            use native DOM elements for \"log line\" to improve performance, Vue is not suitable for managing so many reactive elements. "),
                  _withDirectives(_createElementVNode("div", {
                    class: "job-step-logs",
                    ref_for: true,
                    ref: "logs"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.currentJobStepsStates[i].expanded]
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}